import api from 'api';
import moment from 'moment';
import { push } from 'react-router-redux';
import { fetchClient } from '../../actions/ClientActions';
import { EVALUATION_CLIENT_STAGE_ID } from '../../constants/clientStages';
import CallAnswered from './actions/CallAnswered';
import EvaluateClient from './actions/EvaluateClient';
import ScheduleNextOrComplete from './actions/ScheduleNextOrComplete';
import BookFollowUpCallStep from './BookFollowUpCallStep';
import BookFollowUpOptionsStep from './BookFollowUpOptionsStep';
import BookMeetingStep from './BookMeetingStep';
import ConversationStep from './ConversationStep';
import EditCallStep from './EditCallStep';
import LogCallStep from './LogCallStep';
import MarkAsDudStep from './MarkAsDudStep';
import ScheduleCallStep from './ScheduleCallStep';
import SuccessScreenStep from './SuccessScreenStep';
import WarnAgainstNoFergusAccountStep from './WarnAgainstNoFergusAccountStep';


var availableSteps = [
	{key: 'LogCallStep', component: LogCallStep},
	{key: 'BookFollowUpOptionsStep', component: BookFollowUpOptionsStep},
	{key: 'ConversationStep', component: ConversationStep},
	{key: 'BookFollowUpCallStep', component: BookFollowUpCallStep},
	{key: 'BookMeetingStep', component: BookMeetingStep},
	{key: 'WarnAgainstNoFergusAccountStep', component: WarnAgainstNoFergusAccountStep},
	{key: 'MarkAsDudStep', component: MarkAsDudStep},
	{key: 'SuccessScreenStep', component: SuccessScreenStep},
	{key: 'EditCallStep', component: EditCallStep},
	{key: 'ScheduleCallStep', component: ScheduleCallStep},	
];

var initialState = {
	wizardTitle: 'Log Phone Call',
	activityType: 'call', // meeting
	isOpen: false,
	activeStepIndex: 0,
	currentStep: null,
	steps: [],
	callData: {},
	meetingData: {},
	clientData: {},
	activeScheduledCallIndex: 0,
	scheduledCallData: [],
	activeScheduledMeetingIndex: 0,
	scheduledMeetingData: [],
	clientDudData: {},
	isSaving: false,
	wizardPosition: 'right',
	wizardWidth: 500,
	autoFocusNotes: false,
	showCompletedSuccess: false,
	HubComponent: null,
	actionsSteps: [],
	actionStepIndex: 0,
	showStackedStep: false,
	stackedStepComponent: null,
	stackedStepComponentName: null
};

export default function logActivityWizard(state = initialState, action = {}) {
	switch(action.type) {
		case 'OPEN_STACKED_STEP':
			return {
				...state,
				showStackedStep: true,
				stackedStepComponent: action.Component				
			};
		case 'STACK_SCHEDULED_CALL_STEP':
			return {
				...state,
				showStackedStep: true,
				stackedStepComponent: action.Component,
				scheduledCallData: action.scheduledCallData,
				activeScheduledCallIndex: action.activeScheduledCallIndex,
				stackedStepComponentName: 'ScheduleCallStep'
			};
		case 'STACK_SCHEDULED_MEETING_STEP':
			return {
				...state,
				showStackedStep: true,
				stackedStepComponent: action.Component,
				scheduledMeetingData: action.scheduledMeetingData,
				activeScheduledMeetingIndex: action.activeScheduledMeetingIndex,
				stackedStepComponentName: 'BookMeetingStep'
			};
		case 'SAVE_STACKED_STEP_AND_GO_BACK':
			return {
				...state,
				showStackedStep: false
			};
		case 'CANCEL_STACKED_STEP':
			return {
				...state,
				showStackedStep: false,
				...action.data
			};
		case 'GO_FORWARD_IN_ACTION': // refactor to move forward in step
			return {
				...state,
				actionStepIndex: state.actionStepIndex + 1
			};
		case 'GO_BACK_IN_ACTION':
			return {
				...state,
				actionStepIndex: state.actionStepIndex - 1
			};
		case 'GO_TO_NEXT_ACTION':
			var lastStep = state.actionsSteps[state.actionsSteps.length -1];
			var lastStepCharCode = lastStep.id.charCodeAt(0);
			var nextStepChar = String.fromCharCode(++lastStepCharCode);

			return {
				...state,
				actionStepIndex: state.actionStepIndex + 1,
				actionsSteps: state.actionsSteps.concat({
					id: nextStepChar,
					Component: action.Component
				})
			};
		case 'SHOW_COMPLETED_SUCCESS_SCREEN':
			return {
				...state,
				showCompletedSuccess: true				
			};
		case 'OPEN_LOG_UNSCHEDULED_CALL_WIZARD':
			return {
				...state,
				isOpen: true,
				callData: action.callData,
				HubComponent: LogCallStep,
				actionsSteps: action.actionsSteps
			};
		case 'OPEN_WIZARD_TO_LOG_SCHEDULED_CALL':
			return {
				...state,
				isOpen: true,
				...action.payload
			};
		case 'OPEN_WIZARD_TO_SCHEDULE_CALL':
			var { scheduledCallData } = action;

			return {
				...state,
				wizardTitle: 'Schedule Call',
				isOpen: true,
				scheduledCallData,
				HubComponent: ScheduleCallStep,
			};
		case 'OPEN_WIZARD_TO_LOG_INCOMING_CALL':
			var { steps, currentStep, callData } = action;

			return {
				...state,
				wizardTitle: 'Log incoming call',
				isOpen: true,
				callData,
				HubComponent: LogCallStep,
				actionsSteps: [{
					id: 'a',
					Component: ScheduleNextOrComplete
				}]
			};
		case 'OPEN_WIZARD_TO_UPDATE_SCHEDULED_CALL':
			var { steps, currentStep } = action;

			var callData = {...action.callData, wantsToUpdate: true };

			return {
				...state,
				wizardTitle: 'Update call',
				isOpen: true,
				callData,
				HubComponent: EditCallStep
			};
		case 'OPEN_WIZARD_TO_SCHEDULE_MEETING':
			var { scheduledMeetingData } = action;

			return {
				...state,
				wizardTitle: 'Schedule meeting',
				isOpen: true,
				scheduledMeetingData,
				HubComponent: BookMeetingStep
			};
		case 'UPDATE_CALL_DATA':
			var callData = {...state.callData, ...action.data };

			return {
				...state,
				callData
			};
		// would call GO_TO_STEP but henry took it :)
		case 'PUSH_STEP':
			return {
				...state,
				currentStep: action.currentStep,
				steps: action.steps
			};
		case 'LOAD_SCHEDULE_CALL_DATA':
			var scheduledCallData = {...state.scheduledCallData, ...action.scheduledCallData };

			return {
				...state,
				scheduledCallData
			};
		case 'LOAD_SCHEDULE_MEETING_DATA':
			var scheduledMeetingData = {...state.scheduledMeetingData, ...action.scheduledMeetingData };

			return {
				...state,
				scheduledMeetingData
			};
		case 'UPDATE_SCHEDULED_CALL_DATA':
			var scheduledCallData = state.scheduledCallData.map((callData, i) =>
				i != state.activeScheduledCallIndex ? 
					callData : 
					{...callData, ...action.data}
			);

			return {
				...state,
				scheduledCallData
			};
		case 'UPDATE_SCHEDULED_MEETING_DATA':
			var scheduledMeetingData = state.scheduledMeetingData.map((meetingData, i) =>
				i != state.activeScheduledMeetingIndex ? 
					meetingData : 
					{...meetingData, ...action.data}
			);

			return {
				...state,
				scheduledMeetingData
			};
		case 'CANCEL_FOLLOW_UP':
			return {
				...state,
				scheduledCallData: {...state.scheduledCallData, cancel: true }
			};
		case 'GO_BACK_IN_ACTIVITY_WIZARD':
			var steps = state.steps;

			var currentStepIndex = steps.findIndex(step => step.key == state.currentStep);
			var newCurrentStepIndex = currentStepIndex -1;
			var currentStep = steps[newCurrentStepIndex].key;			

			return {
				...state,
				currentStep
			};
		case 'CLOSE_ACTIVITY_WIZARD':
			return initialState;
		case 'START_SAVING_WIZARD':
			return {
				...state,
				isSaving: true
			};
		case 'COMPLETED_SAVING_WIZARD':
			return {
				...state,
				isSaving: false
			};
		case 'CHANGE_WIZARD_WIDTH':
			return {
				...state,
				wizardWidth: action.width
			};
		case 'CHANGE_WIZARD_POSITION':
			return {
				...state,
				wizardPosition: action.position
			};
		default:
			return state;
	}
}

var redirectAndLoadClientIfNeeded = async (state, clientId, dispatch) => {
	var clientPathname = `/clients/${clientId}`;
	var isOnClientPage = state.routing.locationBeforeTransitions.pathname === clientPathname;

	if(! isOnClientPage) {
		dispatch({
			type: 'FLASH_DISABLE_LOADING_ON_MOUNT'
		});
		dispatch(push(clientPathname));
		await dispatch(fetchClient(clientId));
	}

	return true;
};

export function goToStep(stepKey) {
	return (dispatch, getState) => {
		var currentSteps = getState().logActivityWizard.steps;
		var exists = currentSteps.map(s => s.key).includes(stepKey);
		var stepRequested = availableSteps.find(step => step.key == stepKey);
		if(! stepRequested) {
			throw "STEP REQUESTED DOES NOT EXIST";
		}

		// if have gone back and now going forward to a different step then take out old new step
		var steps = exists ? currentSteps : [...currentSteps, stepRequested];
		dispatch({
			type: 'PUSH_STEP', 
			currentStep: stepKey,
			steps
		});
	};
}

var getDefaultContact = (client, contacts) => {
	if(client.lastContactedId) return client.lastContactedId;
	if(! contacts.length) return null;

	return contacts[0].id;
};

export function openWizardForUnscheduledCall(clientId) {
	return async (dispatch, getState) => {
		if(clientId) {
			await redirectAndLoadClientIfNeeded(
				getState(),
				clientId,
				dispatch
			);	
		}

		var { client, contacts } = getState().activeClient;
		
		var participatingContactId = getDefaultContact(client, contacts);

		dispatch({
			type: 'OPEN_LOG_UNSCHEDULED_CALL_WIZARD', 
			callData: {
				notes: '',
				date: moment(),
				participatingContactId
			},
			actionsSteps: [{
				id: 'a',
				Component: CallAnswered
			}]
		});
	}	
}

export function openWizardForIncomingCall(clientId) {
	return async (dispatch, getState) => {
		if(clientId) {
			await redirectAndLoadClientIfNeeded(
				getState(),
				clientId,
				dispatch
			);	
		}

		var { client, contacts } = getState().activeClient;
		var participatingContactId = getDefaultContact(client, contacts);

		var callData = {
			notes: '',
			date: moment(),
			participatingContactId
		};

		dispatch({
			type: 'OPEN_WIZARD_TO_LOG_INCOMING_CALL', 
			callData,
		});
	}
}

export function openWizardToScheduleCall(clientId) {
	return async (dispatch, getState) => {
		if(clientId) {
			await redirectAndLoadClientIfNeeded(
				getState(),
				clientId,
				dispatch
			);
		}

		var state = getState();
		var contacts = state.activeClient.contacts;

		var followUpDate = [5, 6].includes(moment().add(1, 'day')) ?
			moment().weekday(8) : 
			moment().add(1, 'day');

		var scheduledCallData = [{
			date: followUpDate,
			description: '',
			participatingContactId: contacts.length ? contacts[0].id: null,
			assignedEmployeeIds: [state.auth.user.id]
		}];

		dispatch({type: 'OPEN_WIZARD_TO_SCHEDULE_CALL', scheduledCallData});
	}
}

export function openWizardToScheduleMeeting(clientId) {
	return async (dispatch, getState) => {
		if(clientId) {
			await redirectAndLoadClientIfNeeded(
				getState(),
				clientId,
				dispatch
			);
		}
		var scheduledMeetingData = makeScheduledMeetingData(getState());

		dispatch({type: 'OPEN_WIZARD_TO_SCHEDULE_MEETING', scheduledMeetingData});
	}
}

export function openWizardToUpdateCall(callData) {
	return async (dispatch, getState) => {
		var { clientId } = callData;

		await redirectAndLoadClientIfNeeded(
			getState(),
			clientId,
			dispatch
		);

		dispatch({
			type: 'OPEN_WIZARD_TO_UPDATE_SCHEDULED_CALL', 
			callData
		});
	}
}

export function openWizardToCompleteScheduledCall(callData, fromAction) {
	return async (dispatch, getState) => {
		var { clientId } = callData;

		await redirectAndLoadClientIfNeeded(
			getState(),
			clientId,
			dispatch
		);

		var state = getState();

		var { client, contacts } = state.activeClient;

		if(! callData.participatingContactId && contacts.length) {
			callData.participatingContactId = getDefaultContact(client, contacts);
		}

		if(fromAction == 'LEFT_MESSAGE') {
			callData.leftMessage = true;
		}

		if(fromAction == 'NO_ANSWER') {
			callData.noAnswer = true;
		}

		var actionsSteps;
		if(['LEFT_MESSAGE', 'NO_ANSWER'].includes(fromAction)) {
			actionsSteps = [{id: 'a', Component: CallAnswered }, {id: 'b', Component: ScheduleNextOrComplete }];
		} else {
			actionsSteps = client.clientStageId == EVALUATION_CLIENT_STAGE_ID ?
				[{id: 'a', Component: CallAnswered }, {id: 'b', Component: EvaluateClient }] :
				[{id: 'a', Component: CallAnswered }, {id: 'b', Component: ScheduleNextOrComplete }];	
		}

		dispatch({
			type: 'OPEN_WIZARD_TO_LOG_SCHEDULED_CALL', 
			payload: {
				callData,
		        HubComponent: LogCallStep,
		        actionStepIndex: 1,
		        actionsSteps
			}
		});
	}	
}

function hasData(activtyData, key) {
	var data = activtyData[key];
	if(! data) return false;

	return Object.keys(data).length > 0;
}

async function logCall(activtyData, clientId, dispatch) {
	if(! hasData(activtyData, 'callData')) return true;

	var callData = {
		...activtyData.callData,
		clientId
	};

	// updates are handled by updateCall
	if(callData.wantsToUpdate) return true;

	if(! callData.id) {
		var callWithStupidValue = await api.post('schedules/log_completed_call', callData);
		var call = callWithStupidValue.value;
		dispatch({type: 'TIMELINE_EVENT_ADDED', event: call});
	} else {
		// var call
		var callWithStupidValue = await api.post(`phonecalls/${callData.id}/complete`, callData);
		var call = callWithStupidValue.value;
		dispatch({type: 'RECORD_PHONE_CALL_COMPLETE_SUCCESS', result: call});
	}

	return true;
}

async function updateCall(activtyData, clientId, dispatch) {
	if(! hasData(activtyData, 'callData')) return true;

	var callData = {
		...activtyData.callData,
		clientId
	};

	if(! callData.wantsToUpdate) return true;

	var callWithStupidValue = await api.put(`phonecalls/${callData.id}`, callData);
	var call = callWithStupidValue.value;

	dispatch({type: 'UPDATE_SCHEDULE_SUCCESS', result: call});

	return true;
}

export function goToFollowUpCallStep() {
	return (dispatch, getState) => {
		var state = getState();
		var { callData, scheduledCallData } = state.logActivityWizard;

		if(! Object.keys(scheduledCallData).length) {
			var { date, participatingContactId } = callData;
			var loggedCallDate = date;

			var followUpDate = [5, 6].includes(loggedCallDate.day()) ?
	            moment().weekday(8) : 
	            moment().add(1, 'day');

	        var scheduledCallData = {
	            date: followUpDate,
	            description: '',
	            participatingContactId,
	            assignedEmployeeIds: [state.auth.user.id]
	        };

			dispatch({type: 'LOAD_SCHEDULE_CALL_DATA', scheduledCallData});
		}

		dispatch(goToStep("BookFollowUpCallStep"));
	};
}

export function goToBookMeetingStep() {
	return (dispatch, getState) => {
		var state = getState();
		var { scheduledMeetingData } = state.logActivityWizard;

		if(! Object.keys(scheduledMeetingData).length) {
	        var scheduledMeetingData = {
	            date: moment().add(1, 'day'),
	            assignedEmployeeIds: [state.auth.user.id],
	            meetingType: 'demo',
	            location: 'web',
	            description: ''
	        };

			dispatch({type: 'LOAD_SCHEDULE_MEETING_DATA', scheduledMeetingData});
		}

		dispatch(goToStep("BookMeetingStep"));
	};
}


// saveCompletedScheduledCall
// switch step based on no answer left message or answered
async function saveScheduledCalls(activtyData, clientId, dispatch) {
	var scheduledCalls = activtyData.scheduledCallData.filter(c => ! c.cancel);
	if(! scheduledCalls.length) return true;

	var callWithStupidValue = await api.post('schedules/schedule_phone_calls', {
		scheduledCalls,
		clientId
	});
	
	callWithStupidValue.value.forEach(call =>
		dispatch({type: 'TIMELINE_EVENT_ADDED', event: call})
	);

	return true;
}

async function saveScheduledMeetings(activtyData, clientId, dispatch) {
	var scheduledMeetings = activtyData.scheduledMeetingData.filter(c => ! c.cancel);
	if(! scheduledMeetings.length) return true;

	var meetingsWithStupidValue = await api.post('schedules/schedule_meetings', {
		scheduledMeetings,
		clientId
	});
	
	meetingsWithStupidValue.value.forEach(meeting =>
		dispatch({type: 'TIMELINE_EVENT_ADDED', event: meeting})
	);

	return true;
}


export function completeAndMarkAsDud(clientDudData) {
	return (dispatch, getState) => {
		var state = getState();
		var clientId = state.activeClient.client.id;
		var { closeOffNotes, closeOffReasons } = clientDudData;
		var closeOffReasons = closeOffReasons.map(r => r.id);

		api.post(`clients/${clientId}/mark_as_dud`, {closeOffNotes, closeOffReasons})
			.then(clientWithStupidValue => {
				var client = clientWithStupidValue.value;
				console.log('client', client);
				dispatch({type: 'MARK_AS_DUD_SUCCESS', result: client});
				dispatch(completeWizard());
			});
	};
}

export function completeWithNoFollowUpCall(data) {
	return (dispatch, getState) => {
		var state = getState();
		dispatch({type: 'CANCEL_FOLLOW_UP'});

		dispatch(completeWizard());
	};
}

export function completeWizard() {
	return (dispatch, getState) => {
		var state = getState();

		dispatch({type: 'START_SAVING_WIZARD'});

		var activtyData = state.logActivityWizard;
		var clientId = state.activeClient.client.id;

		Promise.all([
			logCall(activtyData, clientId, dispatch),
			updateCall(activtyData, clientId, dispatch),
			saveScheduledCalls(activtyData, clientId, dispatch),
			saveScheduledMeetings(activtyData, clientId, dispatch)				
		]).then(call => {
			api.get(`clients/${clientId}`)
				.then(clientWithValue => {
					var client = clientWithValue.value;
					dispatch({type: 'CLIENT_REFRESHED', client});

					dispatch(showCompletedSuccessScreen());
					setTimeout(() => {
						dispatch(closeWizard());
					}, 650);
				});
		});
	};
}

export function openEmailForSelectedContact({ contacts, participatingContactId }) {
	var emailAddress = contacts.reduce((acc, c) => {
	    if(acc.length) return acc;

	    var contact = c.id == participatingContactId ? c : null;
	    if(contact && contact.emails.length > 0) return contact.emails[0].email;

	    return acc;
	}, '');

	window.open(`https://mail.google.com/mail/u/0/?view=cm&fs=1&tf=1&source=mailto&to=${emailAddress}`);
}

export function emailAndCompleteWizard() {
	return (dispatch, getState) => {
		var state = getState();
		var { contacts } = state.activeClient;
		openEmailForSelectedContact({ contacts, scheduledCallData });
		dispatch(completeWizard());
	};
}

export function saveStackedStepAndGoBack() {
	return {type: 'SAVE_STACKED_STEP_AND_GO_BACK'};
}

export function cancelStackedStep() {
	return (dispatch, getState) => {
		var state = getState();

		var data = {};

		var { stackedStepComponentName } = state.logActivityWizard;
		
		if(stackedStepComponentName == 'ScheduleCallStep') {
			var { scheduledCallData, activeScheduledCallIndex } = state.logActivityWizard;

			var scheduledCallData = scheduledCallData.map((callData, i) =>
				activeScheduledCallIndex == i ? {...callData, cancel: true} : callData
			);
			data.scheduledCallData = scheduledCallData;
		}

		if(stackedStepComponentName == 'BookMeetingStep') {
			var { scheduledMeetingData, activeScheduledMeetingIndex } = state.logActivityWizard;
			scheduledMeetingData[activeScheduledMeetingIndex].cancel = true;
			data.scheduledMeetingData = scheduledMeetingData;
		}

		dispatch({type: 'CANCEL_STACKED_STEP', data});
	};
}

function makeScheduledCallData(state) {
	var { logActivityWizard } = state;
	var { date, participatingContactId } = logActivityWizard.callData;
	var { scheduledCallData } = logActivityWizard;

	var lastScheduledCall = scheduledCallData[scheduledCallData.length -1];
	if(lastScheduledCall && lastScheduledCall.cancel) {
		delete lastScheduledCall.cancel;
		
		return scheduledCallData.map((call, i, calls) =>
			calls.length -1 == i ? lastScheduledCall : call
		);
	}

	var followUpDate = [5, 6].includes(date.day()) ?
        moment().weekday(8) : 
        moment().add(1, 'day');

    var scheduledCallObj = {
        date: followUpDate,
        description: '',
        participatingContactId,
        assignedEmployeeIds: [state.auth.user.id]
    };

    return scheduledCallData.concat(scheduledCallObj);
}

function makeScheduledMeetingData(state) {
	var { logActivityWizard, auth } = state;
	var { scheduledMeetingData } = logActivityWizard;

	var lastScheduledMeeting = scheduledMeetingData[scheduledMeetingData.length -1];
	if(lastScheduledMeeting && lastScheduledMeeting.cancel) {
		delete lastScheduledMeeting.cancel;
		
		// don't think map makes a difference, delete has already mutated it
		return scheduledMeetingData.map((meeting, i, meetings) =>
			meetings.length -1 == i ? lastScheduledMeeting : meeting
		);
	}

	var meetingDate = [5, 6].includes(moment()) ?
        moment().weekday(8) : 
        moment().add(1, 'day');

    var scheduledMeetingObj = {
    	date: meetingDate,
    	assignedEmployeeIds: [auth.user.id],
    	meetingType: 'demo',
    	location: 'web',
    	description: ''
    };

    return scheduledMeetingData.concat(scheduledMeetingObj);
}


export function openStackedStep(componentName) {
	return (dispatch, getState) => {
		
		if(componentName == 'ScheduleCallStep') {
			var scheduledCallData = makeScheduledCallData(getState());

			return dispatch({
				type: 'STACK_SCHEDULED_CALL_STEP', 
				Component: ScheduleCallStep,
				scheduledCallData,
				activeScheduledCallIndex: scheduledCallData.length - 1
			});
		}

		if(componentName == 'MarkAsDudStep') {
			return dispatch({type: 'OPEN_STACKED_STEP', Component: MarkAsDudStep});	
		}

		if(componentName == 'BookMeetingStep') {
			var scheduledMeetingData = makeScheduledMeetingData(getState());

			return dispatch({
				type: 'STACK_SCHEDULED_MEETING_STEP', 
				Component: BookMeetingStep,
				scheduledMeetingData,
				activeScheduledMeetingIndex: scheduledMeetingData.length - 1
			});
		}
	};
}

export function noAnswerSelected() {
	return (dispatch, getState) => {
		dispatch(updateCallData({noAnswer: true}));
		dispatch(goToNextAction(ScheduleNextOrComplete));
	};
}

export function goBackInAction() {
	return {type: 'GO_BACK_IN_ACTION'};
}

export function goForwardInAction() {
	return {type: 'GO_FORWARD_IN_ACTION'};
}

export function goBack() {
	return {type: 'GO_BACK_IN_ACTIVITY_WIZARD'};
}

export function updateCallData(data) {
	return {type: 'UPDATE_CALL_DATA', data};
}

export function goToNextAction(Component) {
	return {type: 'GO_TO_NEXT_ACTION', Component};
}

export function updateScheduledCallData(data) {
	return {type: 'UPDATE_SCHEDULED_CALL_DATA', data};
}

export function updateScheduledMeetingData(data) {
	return {type: 'UPDATE_SCHEDULED_MEETING_DATA', data};
}

export function showCompletedSuccessScreen() {
	return {type: 'SHOW_COMPLETED_SUCCESS_SCREEN'};
}

export function closeWizard() {
	return {type: 'CLOSE_ACTIVITY_WIZARD'};
}

export function changeWidth(width) {
	return {type: 'CHANGE_WIZARD_WIDTH', width};
}

export function changePosition(position) {
	return {type: 'CHANGE_WIZARD_POSITION', position};
}



// WEBPACK FOOTER //
// ./app/components/schedule-wizard/logActivityReducer.js